<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>金币基础配置</span>
          <el-button
            v-permisaction="['config:activityCoins:add']"
            style="margin-top: 10px;margin-left: 10px;"
            type="primary"
            icon="el-icon-plus"
            size="mini"
            @click="edit(0)"
          >新增</el-button>
          <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
            <el-col :span="1.5">
              <el-upload
                ref="upload"
                class="upload-demo"
                :action="sys_app_logoAction"
                accept="xlsx"
                :limit="1"
                :on-success="(res)=>{return importProbUploadSuccess(res)}"
                :headers="headers"
              >
                <el-button v-permisaction="['config:activityCoins:import']" :loading="loading" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
              </el-upload>
            </el-col>

            <el-col :span="1.5">
              <el-button
                v-permisaction="['config:activityCoins:export']"
                type="primary"
                icon="el-icon-download"
                size="mini"
                @click="exportData()"
              >导出</el-button>
            </el-col>
            <el-col :span="1.5">
              <clear-cache-apply />
            </el-col>
            <el-col :span="1.5">
              <sync-data />
            </el-col>
          </el-row>
        </div>

        <el-table
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="levelId"
            label="等级"
          />

          <el-table-column
            prop="collect"
            label="收集"
          />

          <el-table-column
            prop="attack"
            label="打"
          />

          <el-table-column
            prop="steal"
            label="偷"
          />

          <el-table-column
            prop="rank"
            label="排行榜"
          />

          <el-table-column
            prop="starExchange"
            label="星星兑换"
          />

          <el-table-column
            prop="architecture"
            label="建筑大师"
          />

          <el-table-column
            prop="accumulated_pay"
            label="累冲"
          />

          <el-table-column
            prop="super_serial_pack"
            label="超级连环礼包"
          />

          <!--          <el-table-column-->
          <!--            prop="coin_dozer"-->
          <!--            label="推金币"-->
          <!--          />-->

          <el-table-column
            prop="super_balloon"
            label="超级气球"
          />

          <el-table-column
            prop="easter_egg"
            label="复活彩蛋"
          />

          <el-table-column
            prop="dice_extra_coin"
            label="相同点数"
          />

          <el-table-column
            prop="signIn"
            label="签到"
          />

          <el-table-column
            prop="runForMoney"
            label="捡钱快跑"
          />

          <el-table-column
            prop="rand_card"
            label="随机卡"
          />

          <el-table-column
            prop="actTreasure"
            label="金币老虎机"
          />

          <el-table-column
            prop="recall"
            label="回归奖励"
          />

          <el-table-column
            fixed="right"
            label="操作"
            width="200"
          >
            <template slot-scope="scope">
              <el-button size="mini" @click="edit(scope.row.levelId)">编辑</el-button>
              <el-button size="mini" type="danger" @click="del(scope.row.levelId)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getToken } from '@/utils/auth'
import {
  delActivityCoinCfg,
  exportActivityCoinCfg,
  getActivityCoinCfgList,
  importActivityCoinCfg,
  updateActivityCoinCfg
} from '@/api/config/activity-coin-cfg'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'
export default {
  name: 'ActivityCoins',
  components: { SyncData, ClearCacheApply },
  data() {
    return {
      loading: false,
      configVisibleArr: [{ visible: false }],
      rewardVisibleArr: [{ visible: false }],
      total: 0,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      tableData: [
        {
          'levelId': 0,
          'collect': 0,
          'attack': 0,
          'steal': 0,
          'rank': 0,
          'treasureCollect': 0,
          'treasureReward': 0,
          'treasureBet': 0,
          'starExchange': 0,
          'architecture': 0,
          'accumulated_pay': 0,
          'super_serial_pack': 0,
          'coin_dozer': 0,
          'super_balloon': 0,
          'easter_egg': 0,
          'dice_extra_coin': 0,
          'signIn': 0,
          'runForMoney': 0,
          actTreasure: 0
        }
      ]
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    onSubmit() {
      const data = JSON.stringify(this.formData)
      // console.log(data)
      updateActivityCoinCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getActivityCoinCfgList(this.queryParams).then(res => {
        if (res.code === 200) {
          const _tableData = []
          // this.tableData = res.data.list
          res.data.list.list.forEach(item => {
            const tempData = Object.assign({}, this.tableData[0])
            tempData.levelId = item.level
            _tableData.push(tempData)
          })
          // console.log(_tableData)
          for (const i in _tableData) {
            const _data = _tableData[i]
            console.log('_data', _data)
            for (const d in res.data.list.data) {
              const _d = res.data.list.data[d]
              if (_data.levelId === _d.level) {
                _tableData[i][_d.type] = _d.value
              }
            }
          }
          this.tableData = _tableData
          console.log(this.tableData)
          this.total = res.data.count
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      this.formData.push({
        'levelId': 0,
        'collect': 0,
        'attack': 0,
        'steal': 0,
        'rank': 0,
        'treasureCollect': 0,
        'treasureReward': 0,
        'treasureBet': 0,
        'starExchange': 0,
        'architecture': 0,
        'accumulated_pay': 0,
        'super_serial_pack': 0,
        'coin_dozer': 0,
        'super_balloon': 0,
        'easter_egg': 0,
        'signIn': 0,
        'runForMoney': 0,
        actTreasure: 0
      })
    },
    edit(id) {
      this.$router.push({ name: 'ActivityCoinsEdit', query: { id: id }})
    },
    del(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delActivityCoinCfg({ id: id }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    exportData() {
      exportActivityCoinCfg().then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importProbUploadSuccess(response) {
      this.loading = true
      this.$refs.upload.clearFiles()
      importActivityCoinCfg({ data: response.data.path }).then(res => {
        // eslint-disable-next-line eqeqeq
        this.loading = false
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
